interface NftDetails {
  nftSymbol: string;
}

const nftDetails: NftDetails = {
  nftSymbol: "USDT",
};

export default nftDetails;
